import { apiFetch } from '../../lib/apiFetch';
import { SERVICE_MAPPER_API_BASE } from './utils/constants';

// ─── Types mirroring backend ScopeSummaryModels.cs ───────────────────────────

export type DiscoveryStatus = 'Discovered' | 'Partial' | 'NotFound' | 'Missing';

export interface EntityTypeCoverage {
  entityType: string;
  label: string;
  sysClassName: string;
  total: number;
  discovered: number;
  status: DiscoveryStatus;
}

export interface ApplicationServiceSummary {
  sysId: string;
  name: string;
  applicationId: string;
  operationalStatus: string;
  coveredEntityTypes: number;
  totalEntityTypes: number;
  coveragePercent: number;
  entityCoverage: EntityTypeCoverage[];
  overallStatus: DiscoveryStatus;
}

export interface ScopeSummaryResponse {
  supportGroup: string;
  totalApplicationServices: number;
  fullyDiscovered: number;
  partiallyDiscovered: number;
  notDiscovered: number;
  services: ApplicationServiceSummary[];
  fetchedAt: string;
}

// ─── API client ───────────────────────────────────────────────────────────────

const SCOPE_API = `${SERVICE_MAPPER_API_BASE.replace('/api/servicenow', '')}/api/servicenow/scope`;

export async function fetchScopeSummary(supportGroup: string): Promise<ScopeSummaryResponse> {
  const url = `${SCOPE_API}/summary?supportGroup=${encodeURIComponent(supportGroup)}`;
  const res = await apiFetch(url);

  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`Scope summary API error ${res.status}: ${text}`);
  }

  const envelope = await res.json();
  if (!envelope.success) {
    throw new Error(envelope.error ?? 'Unknown error from scope summary API');
  }

  return envelope.data as ScopeSummaryResponse;
}
